module.exports = __webpack_public_path__ + "static/img/6767_phase_function_Paper_PointsHejduk_Prediction.c5f15f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6767_phase_function_Paper_PointsHejduk_Prediction.png
// module id = E07S
// module chunks = 0